import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Context/AppContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import AppSettings from "../../../Settings/AppSettings";
import ProductsTableViewSearch from "./ProductsTableViewSearch";
import SkeletonElement from "../Category/Shimmer/SkeletonElement";

function SearchManage(props) {
  const appData = useContext(AppContext);
  let [loading, setLoading] = React.useState(true);
  const [loaded, setLoaded] = useState(false);
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (
      props.props.match.params.query &&
      props.props.match.params.query !== ""
    ) {
      search(props.props.match.params.query);
    } else {
      setResponse(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  async function search(query) {
    setLoading(true);
    setLoaded(false);
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    const industryId =
      appData.get_selected_industry() && appData.get_selected_industry().id;
    let res = await ServiceWrapper.doGet(
      api_base_url +
        "globalsearch/" +
        industryId +
        "/search?searchtext=" +
        encodeURIComponent(query),
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      res.data.result.forEach(function (result) {
        if (result["entity"] === "Product") {
          result.data.forEach(function (data) {
            data.page = 1;
            data.limit = 100;
          });
        }
      });
      setLoaded(true);
      if (res.data.result.length > 0) {
        setResponse(res);
      } else {
        setResponse(null);
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <div className="container-fluid p-5" data-testid="search-results-page" aria-busy={loading || undefined}>
        {loading && (
          <div>
            <div className="border ps-3">
              <SkeletonElement type={"title25"} />
            </div>
            <br />
            <br />
            <div className="border ps-3">
              <SkeletonElement type={"title25"} />
            </div>
            <br />
            <br />
            <div className="border ps-3">
              <SkeletonElement type={"title25"} />
            </div>
            <br />
            <br />
            <div className="border ps-3">
              <SkeletonElement type={"title25"} />
            </div>
          </div>
        )}
        {loaded &&
          (response ? (
            <ProductsTableViewSearch res={response} />
          ) : (
            <div className="text-center" data-testid="search-empty-message">
              <label
                style={{
                  fontWeight: "400",
                  fontFamily: "Noto Sans",
                }}
              >
                No Results Found!!
              </label>
            </div>
          ))}
      </div>
    </React.Fragment>
  );
}

export default SearchManage;
